<template v-if="data_local">
  <div id="exhibitor-type">
    <div class="vx-row">
      <div class="vx-col md:w-12/12 w-full mt-2">
        <label>Type Name</label>
        <vs-input
          class="inputx w-full"
          name="Type"
          v-model="data_local.TypeName"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Type')">{{
          errors.first("Type")
        }}</span>
      </div>
      <div class="vx-col md:w-12/12 w-full mt-2">
        <label>Background Image (2000px x 1125px)</label>
        <div v-if="imgSrc" class="exhibitor-edit-preview-image-wrap exhibitorimage-wrap">
          <img :src="imgSrc" />
        </div>
        
        <vs-input
          type="file"
          class="inputx w-full"
          name="BackgroundImg"
          @change="upload_bgimg"
          accept="image/*"
        />
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-4 mt-2"
            @click="before_save()"
            color="success"
            >Save</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TypeForm',
  props: {
    data: {
      Type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      imgSrc: this.data.BackgroundImg,
      file: null
    }
  },
  mounted(){

  },
  methods: {
    before_save(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.save_changes();
        }
      });
    },
    upload_bgimg(input) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };
        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        this.file = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imgSrc = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    save_changes(){
      this.$vs.loading();
      if (this.data_local.TypeId) {
        this.$store
          .dispatch("exhibitorManagement/updateExhibitorType", {
            TypeId: this.data_local.TypeId,
            data: this.data_local,
            file: this.file
          })
          .then((res) => {
            this.$store.dispatch("exhibitorManagement/fetchExhibitorTypes")
            this.$vs.loading.close();
            if (res.status == 200) {
              this.$emit("closePopup");
              this.$vs.notify({
                color: "success",
                position: "top-center",
                text: "Exhibitor type updated successfully.",
              });
            }              
          })
          .catch((err) => {
            this.$vs.loading.close();
          });
        } else {
          this.$store
            .dispatch("exhibitorManagement/addExhibitorType", {
              data: this.data_local,
              file: this.file
            })
            .then((res) => {
              this.$store.dispatch("exhibitorManagement/fetchExhibitorTypes")
              this.$vs.loading.close();
              if (res.status == 200) {
                this.$emit("closePopup");
                this.$vs.notify({
                color: "success",
                position: "top-center",
                text: "Exhibitor type created successfully.",
              });
              }
            })
            .catch((err) => {
              this.$vs.loading.close();
            });
        }
    }
  }
}
</script>
